import {
  Box,
  Button,
  CircularProgress,
  Container,
  FormControl,
  FormControlLabel,
  Link,
  Radio,
  RadioGroup,
  Step,
  StepLabel,
  Stepper,
  TextField,
  Typography,
  useMediaQuery
} from '@material-ui/core';
import { StepIconProps } from '@material-ui/core/StepIcon';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import { useEffect, useState } from 'react';
import { MdCheck, MdDone, MdErrorOutline } from "react-icons/md";
import { useHistory, useParams } from 'react-router-dom';
import { Breadcrumb } from '../../Components';
import RatingEvaluation from '../../Components/RatingEvaluation';
import { Evaluation } from '../../interfaces/agendamentos';
import { avaliacao, getAvaliacao } from '../../services/atendimentos';
import { extractDateFormat } from '../../utils/dateFormat';
import getCookie from '../../utils/getCookies';
import useStyles from './style';

type Params = {
  ticket: string;
};

const useColorlibStepIconStyles = makeStyles({
  root: {
    backgroundColor: '#fff',
    border: '1px solid #ccc',
    color: '#ccc',
    padding: 5,
    textAlign: 'center',
    borderRadius: '50%',
    width: 30,
    height: 30,
  },
  active: {
    border: '1px solid #0BB07B',
    backgroundColor: '#0BB07B',
    color: '#fff',
  },
  completed: {
    border: '1px solid #0BB07B',
    backgroundColor: '#0BB07B',
    color: '#fff',
  },
});

const ColorlibStepIcon = (props: StepIconProps) => {
  const classes = useColorlibStepIconStyles();
  const { active, completed } = props;

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
        [classes.completed]: completed,
      })}
    >
      {completed ? <MdCheck style={{ height: 20, width: 20 }} /> : props.icon}
    </div>
  );
}

export default function EvaluationAttOnline(): JSX.Element {
  const classes = useStyles();
  const [activeStep, setActiveStep] = useState(0);
  const { ticket }: Params = useParams();
  const [commentService, setCommentService] = useState<string>("");
  const [commentAttendance, setCommentAttendance] = useState<string>("");
  const [ratingService, setRatingService] = useState<number>(0);
  const [ratingAttendance, setRatingAttendance] = useState<number>(0);
  const [problemResolution, setProblemResolution] = useState("");
  const [schedule, setSchedule] = useState<undefined | Evaluation>();
  const [loading, setLoading] = useState<boolean>(false);
  const [isOk, setIsOk] = useState<boolean>(false);
  const history = useHistory();
  const matchesMobile = useMediaQuery("(max-width:458px)");
  const token: string | null = getCookie("gov_access_token_sso");

  const linksBreadcrumb = [
    {
      name: "Meus Agendamentos",
      redirectTo: "/workspace/meus_agendamentos",
    },
    {
      name: "Avaliação de atendimento online",
      redirectTo: "#",
    },
  ];

  const steps = [
    {
      id: "SERVICO",
      title: "Avaliar o consumo",
    },
    {
      id: "ATENDENTE",
      title: "Avaliar o atendente",
    },
    {
      id: "SATISFACAO",
      title: "Avaliar a solução",
    },
  ];

  const handleNext = () => {
    setActiveStep((oldStep) => oldStep + 1);
  };

  const handleEvaluationAttendancePresential = async () => {
    try {
      if (schedule) {
        const { data } = await avaliacao(
          schedule.id,
          false,
          ratingService,
          ratingAttendance,
          commentService,
          commentAttendance,
          Number(problemResolution)
        );
        if (data) {
          setIsOk(true);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getSchedule = async (ticket: string) => {
    try {
      setLoading(true);
      const { data } = await getAvaliacao(ticket);
      if (data) {
        setSchedule(data[0]);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (ticket) {
      getSchedule(ticket);
    }
  }, [ticket]);

  return (
    <>
      {token && <Breadcrumb links={linksBreadcrumb} />}
      {!loading ? (
        <Container>
          {!schedule ? (
            <Box className={classes.boxSuccess}>
              <Box className={classes.check}>
                <Box
                  className={classes.boxIcon}
                  style={{ backgroundColor: "#0F6FB7" }}
                >
                  <MdErrorOutline style={{ height: 35, width: 35, color: "#fff" }} />
                </Box>
              </Box>
              <Box
                style={{
                  margin: "40px 0px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Typography className={classes.titleInfo}>
                  A avaliação não pode ser mais realizada!
                </Typography>
                <Typography className={classes.subTitleInfo}>
                  O período de avaliação expirou.
                </Typography>
              </Box>
              <Box
                width="100%"
                className={classes.actions}
                justifyContent="center"
              >
                <Link
                  className={classes.buttonSchedule}
                  href="/"
                  style={{ fontSize: 15 }}
                >
                  Ir para o portal
                </Link>
              </Box>
            </Box>
          ) : (
            <>
              {isOk ? (
                <Box className={classes.boxSuccess}>
                  <Box className={classes.check}>
                    <Box
                      className={classes.boxIcon}
                      style={{ backgroundColor: "#0BB07B" }}
                    >
                      <MdDone style={{ color: "#fff", height: 30, width: 30 }} />
                    </Box>
                  </Box>
                  <Box
                    style={{
                      margin: "40px 0px",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Typography className={classes.titleInfo}>
                      Avaliação realizada com sucesso!
                    </Typography>
                    <Typography className={classes.subTitleInfo}>
                      Obrigado pela sua contribuição.
                    </Typography>
                  </Box>
                  <Box
                    width="100%"
                    className={classes.actions}
                    justifyContent={
                      matchesMobile || !token ? "center" : "space-between"
                    }
                  >
                    {token ? (
                      <>
                        <Button
                          variant="text"
                          size="small"
                          className={classes.buttonReturnAll}
                          onClick={() => history.push("/workspace")}
                        >
                          VOLTAR PARA O INÍCIO
                        </Button>
                        <Button
                          className={classes.buttonSchedule}
                          variant="contained"
                          color="primary"
                          size="small"
                          onClick={() =>
                            history.push("/workspace/meus_agendamentos")
                          }
                        >
                          meus agendamentos
                        </Button>
                      </>
                    ) : (
                      <Link
                        className={classes.buttonSchedule}
                        href="/"
                        style={{ fontSize: 15 }}
                      >
                        Ir para o portal
                      </Link>
                    )}
                  </Box>
                </Box>
              ) : (
                <>
                  <Box className={classes.boxTitle}>
                    <Typography className={classes.title}>
                      Avaliação de atendimento online
                    </Typography>
                  </Box>
                  <Box className={classes.boxInfoService}>
                    <Box className={classes.infoService}>
                      {!loading ? (
                        <>
                          <Typography className={classes.titleService}>
                            {schedule && schedule.servico_titulo}
                          </Typography>
                          <Typography className={classes.detailsService}>
                            {`Horário do atendimento:
                          ${schedule &&
                              extractDateFormat(schedule.data_agendamento)
                              } 
                          às 
                          ${schedule && schedule.hora_agendamento}`}
                          </Typography>
                          <Typography className={classes.ticket}>
                            Ticket: {schedule && schedule.ticket_agendamento}
                          </Typography>
                        </>
                      ) : (
                        <CircularProgress style={{ color: "#FFFFFF" }} />
                      )}
                    </Box>
                  </Box>
                  <Box className={classes.boxEvaluation}>
                    <Box className={classes.evaluation}>
                      <Stepper activeStep={activeStep} alternativeLabel>
                        {steps.map((label) => (
                          <Step key={label.id}>
                            <StepLabel
                              StepIconComponent={ColorlibStepIcon}
                            ></StepLabel>
                          </Step>
                        ))}
                      </Stepper>
                      {steps[activeStep].id === "SERVICO" && (
                        <>
                          <Typography className={classes.infoSlider}>
                            {steps[activeStep].title}
                          </Typography>
                          <Box className={classes.evaluationService}>
                            <FormControl
                              variant="outlined"
                              style={{ width: "100%" }}
                            >
                              <Typography className={classes.text}>
                                Como você avalia sua experiência com o serviço?
                              </Typography>
                              <Box className={classes.boxRating}>
                                <RatingEvaluation
                                  value={ratingService}
                                  onChange={(event, newValue) => {
                                    if (newValue) {
                                      setRatingService(newValue);
                                    }
                                  }} />
                              </Box>
                              <Box
                                width="100%"
                                display="flex"
                                justifyContent="center"
                              >
                                <TextField
                                  className={classes.description}
                                  id="outlined-multiline-static"
                                  label="Deixe seu comentário (opcional)"
                                  multiline
                                  variant="outlined"
                                  rows={5}
                                  onChange={(e) =>
                                    setCommentService(e.target.value)
                                  }
                                  InputProps={{
                                    className: classes.input,
                                  }}
                                />
                              </Box>
                            </FormControl>
                          </Box>
                        </>
                      )}
                      {steps[activeStep].id === "ATENDENTE" && (
                        <>
                          <Typography className={classes.infoSlider}>
                            {steps[activeStep].title}
                          </Typography>
                          <Box className={classes.evaluationService}>
                            <FormControl
                              variant="outlined"
                              style={{ width: "100%" }}
                            >
                              <Typography className={classes.text}>
                                Como você avalia sua experiência com o
                                atendimento?
                              </Typography>
                              <Box className={classes.boxRating}>
                                <RatingEvaluation
                                  value={ratingAttendance}
                                  onChange={(event, newValue) => {
                                    if (newValue) {
                                      setRatingAttendance(newValue);
                                    }
                                  }} />
                              </Box>
                              <Box
                                width="100%"
                                display="flex"
                                justifyContent="center"
                              >
                                <TextField
                                  className={classes.description}
                                  id="outlined-multiline-static"
                                  label="Deixe seu comentário (opcional)"
                                  multiline
                                  variant="outlined"
                                  rows={5}
                                  onChange={(e) =>
                                    setCommentAttendance(e.target.value)
                                  }
                                  InputProps={{
                                    className: classes.input,
                                  }}
                                />
                              </Box>
                            </FormControl>
                          </Box>
                        </>
                      )}
                      {steps[activeStep].id === "SATISFACAO" && (
                        <>
                          <Typography className={classes.infoSlider}>
                            {steps[activeStep].title}
                          </Typography>
                          <Box className={classes.evaluationService}>
                            <FormControl variant="outlined">
                              <Typography className={classes.text}>
                                O seu problema foi resolvido ?
                              </Typography>
                              <RadioGroup
                                name="problemResolution"
                                value={problemResolution}
                                onChange={(e) => setProblemResolution(e.target.value)}
                                className={classes.radioGroup}
                              >
                                <FormControlLabel
                                  value="1"
                                  control={<Radio className={classes.radioButton} />}
                                  label="Totalmente"
                                />
                                <FormControlLabel
                                  value="2"
                                  control={<Radio className={classes.radioButton} />}
                                  label="Parcialmente"
                                />
                                <FormControlLabel
                                  value="3"
                                  control={<Radio className={classes.radioButton} />}
                                  label="Não foi resolvido"
                                />
                              </RadioGroup>
                            </FormControl>
                          </Box>
                        </>
                      )}
                      <Box className={classes.boxActions}>
                        {activeStep === 1 && (
                          <Button
                            variant="contained"
                            size="small"
                            className={classes.buttonReturn}
                            onClick={() => setActiveStep(activeStep - 1)}
                          >
                            Voltar
                          </Button>
                        )}
                        {activeStep < steps.length - 1 && (
                          <Button
                            className={classes.buttonNext}
                            variant="contained"
                            color="primary"
                            size="small"
                            disabled={
                              (steps[activeStep].id === "SERVICO" && !ratingService) ||
                              (steps[activeStep].id === "ATENDENTE" && !ratingAttendance)
                            }
                            onClick={handleNext}
                          >
                            Próximo
                          </Button>
                        )}
                        {activeStep === steps.length - 1 && (
                          <>
                            <Button
                              variant="contained"
                              size="small"
                              className={classes.buttonReturn}
                              onClick={() => setActiveStep(activeStep - 1)}
                            >
                              Voltar
                            </Button>
                            <Button
                              className={classes.buttonNext}
                              variant="contained"
                              color="primary"
                              size="small"
                              disabled={!ratingAttendance || !problemResolution}
                              onClick={handleEvaluationAttendancePresential}
                            >
                              Salvar
                            </Button>
                          </>
                        )}
                      </Box>
                    </Box>
                  </Box>
                </>
              )}
            </>
          )}
        </Container>
      ) : (
        <Box style={{ width: "100%", textAlign: "center" }}>
          <CircularProgress color="primary" />
        </Box>
      )}
    </>
  );
}